import ExplainBCC from './ExplainBCC';

export default ExplainBCC;